// authContext.js
import { createContext, useContext } from 'react';
import { getAccessToken } from '../utils/helper/authHelper';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {


    const user = getAccessToken();

    return (
        <AuthContext.Provider value={{ user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
